import { useContext } from "react";
import { Link } from "react-router-dom";
import { AuthContext } from "src/context/authContext";
import { FooterContext } from "src/context/footerContext";

const Footer = () => {
  const { isUserAuthorized, isManufacturer } = useContext(AuthContext);
  const { isAccordianShown, changeAccordianVisibility } = useContext(FooterContext);


  return (
    <footer className="footer-policy" aria-label="Hub Footer">
      {/* Hub Footer Link Layer */}
      <div className="container-fluid" style={{ backgroundColor: '#3e1052' }}>
        <div className="row justify-content-center text-uppercase mw-100">
          <Link
            to={isUserAuthorized ? (isManufacturer ? `/statistics` : `/cases`) : `/users/sign_in`}
            className="text-white link-underline link-underline-opacity-0 col-auto Hub-Footer-link my-1"
          >
            Home
          </Link>
          <Link
            to="/pages/privacy"
            className="text-white link-underline link-underline-opacity-0 col-auto Hub-Footer-link my-1"
          >
            Privacy Policy
          </Link>
          <a
            href="https://www.exogen.com/us/physician/terms-of-use/"
            target="_blank"
            rel="noreferrer"
            className="text-white link-underline link-underline-opacity-0 col-auto Hub-Footer-link my-1"
          >
            Legal Disclaimer
          </a>
          <a
            href="mailto:suggestions@cmcopilot.com"
            className="text-white link-underline link-underline-opacity-0 col-auto Hub-Footer-link my-1"
          >
            Suggestions
          </a>
        </div>
      </div>

      <div className="prescribing-accordion">
        <div className="accordion" id="accordionExample">
          <h2 className="accordion-header">
            <button
                onClick={changeAccordianVisibility}
                className="accordion-button collapsed px-3 py-1 text-uppercase Hub-Footer-link fw-normal footer-accordian fs-5 text-primary"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseOne"
                aria-expanded="true"
                aria-controls="collapseOne"
            >
              PLEASE SEE IMPORTANT SAFETY INFORMATION AND FULL PRESCRIBING INFORMATION
              {isAccordianShown ? (
                  <i className="bi bi-chevron-down ps-1"></i>
              ) : (
                  <i className="bi bi-chevron-up ps-1"></i>
              )}
            </button>
          </h2>
          <div id="collapseOne" className={`accordion-collapse collapse ${isAccordianShown ? 'show' : ''}`}
               data-bs-parent="#accordionExample">
            <div className="accordion-body container">
              <h2 className="text-primary">Summary of Indications for Use </h2>
              <p>DUROLANE is indicated for the treatment of pain in osteoarthritis (OA) of the knee in patients who
                have
                failed to respond adequately to conservative non-pharmacological therapy or simple analgesics, e.g.
                acetaminophen.</p>
              <p>Do not inject DUROLANE in patients with knee joint infections, skin diseases, or other infections in
                the
                area of the injection site. Do not administer to patients with known hypersensitivity or allergy to
                sodium hyaluronate preparations. Risks can include transient pain or swelling at the injection
                site.</p>
              <p>DUROLANE has not been tested in pregnant or lactating women, or children. Full prescribing
                information
                can be found in product labeling, at www.DUROLANE.com, or by contacting Bioventus Customer Service at
                800-836-4080.</p>
              <p>
                <a
                    target="_blank"
                    rel="noreferrer"
                    href="https://www.durolane.com/wp-content/uploads/2017/09/Bioventus_DUROLANE_3ml_1082015_IFU.pdf"
                ><strong>Please see full prescribing information.</strong></a>
              </p>
              <p>GELSYN-3 is indicated for the treatment of pain in osteoarthritis (OA) of the knee in patients who
                have
                failed to respond adequately to conservative non-pharmacologic therapy and simple analgesics
                (e.g., acetaminophen). Do not administer to patients with known hypersensitivity (allergy) to sodium
                hyaluronate preparations. Do not inject GELSYN-3 into the knees of patients having knee joint
                infections
                or skin diseases or infections in the area of the injection site.</p>
              <p>GELSYN-3 is not approved for pregnant or nursing women, or children. Risks can include general knee
                pain,
                warmth and redness or pain at the injection site. Full prescribing information can be found in product
                labeling, at www.GELSYN3.com or by contacting customer service at 800-836-4080.</p>
              <p>
                <a
                    rel="noreferrer"
                    target="_blank"
                    href="https://www.gelsyn3.com/wp-content/uploads/2016/09/ifu.pdf"
                ><strong>Please see full prescribing information.</strong></a>
              </p>
              <p>SUPARTZ FX is indicated for treatment of pain in osteoarthritis (OA) of the knee in patients who have
                failed to respond adequately to conservative non-pharmacologic therapy and simple analgesics, e.g.,
                acetaminophen. You should not use SUPARTZ FX if you have infections or skin diseases at the injection
                site or allergies to poultry products.</p>
              <p> SUPARTZ FX is not approved for pregnant or nursing women, or children. Risks can include general
                knee
                pain, warmth and redness or pain at the injection site. Full prescribing information can be found at
                www.OASupartzFX.com or by contacting customer service at 800-836-4080.</p>
              <p>
                <a
                    target="_blank"
                    rel="noreferrer"
                    href="http://www.supartzfx.com//wp-content/uploads/2015/07/SUPARTZ_FX_Package_Insert.pdf"
                ><strong>Please see full prescribing information.</strong></a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
